import React from 'react'
import BankingStatment from "../components/MHSSS Accounting/balanceandBanking/bankStatment/BankStatment"

const DashB = () => {
  return (
    <div>
     <BankingStatment/>
    </div>
  )
}

export default DashB